import React from 'react';
import OldHeader from '../components/OldHeader';
import Footer from '../components/Footer';

const Eula = () => {
  return (
    <>
      <OldHeader />
      <div className="template">
        <section className="headline">
          <div className="head">
            {/* <h1>{text.Headline}</h1> */}
            <h1>Eula</h1>
          </div>
          <div className="subHead">
            {/* <p>{text.Subheadline}</p> */}
            {/*<p>Optional subline</p>*/}
          </div>
        </section>
        <section className="body">
          <div className="text">
            {/* <div className="div1">{text.content}</div> */}
            <p>
              End-User License Agreement (EULA) of Mendelgen This End-User
              License Agreement (&quot;EULA&quot;) is a legal agreement between
              you and Mendelgen. Our EULA was created by EULA Template for
              Mendelgen.
            </p>

            <p>
              This EULA agreement governs your acquisition and use of our
              Mendelgen software (&quot;Software&quot;) directly from Mendelgen
              or indirectly through a Mendelgen authorized reseller or
              distributor (a &quot;Reseller&quot;).
            </p>

            <p>
              Please read this EULA agreement carefully before completing the
              installation process and using the Mendelgen software. It provides
              a license to use the Mendelgen software and contains warranty
              information and liability disclaimers.
            </p>

            <p>
              If you register for a free trial of the Mendelgen software, this
              EULA agreement will also govern that trial. By clicking
              &quot;accept&quot; or installing and/or using the Mendelgen
              software, you are confirming your acceptance of the Software and
              agreeing to become bound by the terms of this EULA agreement.
            </p>

            <p>
              If you are entering into this EULA agreement on behalf of a
              company or other legal entity, you represent that you have the
              authority to bind such entity and its affiliates to these terms
              and conditions. If you do not have such authority or if you do not
              agree with the terms and conditions of this EULA agreement, do not
              install or use the Software, and you must not accept this EULA
              agreement.
            </p>

            <p>
              This EULA agreement shall apply only to the Software supplied by
              Mendelgen herewith regardless of whether other software is
              referred to or described herein. The terms also apply to any
              Mendelgen updates, supplements, Internet-based services, and
              support services for the Software, unless other terms accompany
              those items on delivery. If so, those terms apply.
            </p>

            <p>
              License Grant Mendelgen hereby grants you a personal,
              non-transferable, non-exclusive licence to use the Mendelgen
              software on your devices in accordance with the terms of this EULA
              agreement.
            </p>

            <p>
              You are permitted to load the Mendelgen software (for example a
              PC, laptop, mobile or tablet) under your control. You are
              responsible for ensuring your device meets the minimum
              requirements of the Mendelgen software.
            </p>

            <p>You are not permitted to:</p>

            <p>
              Edit, alter, modify, adapt, translate or otherwise change the
              whole or any part of the Software nor permit the whole or any part
              of the Software to be combined with or become incorporated in any
              other software, nor decompile, disassemble or reverse engineer the
              Software or attempt to do any such things Reproduce, copy,
              distribute, resell or otherwise use the Software for any
              commercial purpose Allow any third party to use the Software on
              behalf of or for the benefit of any third party Use the Software
              in any way which breaches any applicable local, national or
              international law use the Software for any purpose that Mendelgen
              considers is a breach of this EULA agreement Intellectual Property
              and Ownership Mendelgen shall at all times retain ownership of the
              Software as originally downloaded by you and all subsequent
              downloads of the Software by you. The Software (and the copyright,
              and other intellectual property rights of whatever nature in the
              Software, including any modifications made thereto) are and shall
              remain the property of Mendelgen.
            </p>

            <p>
              Mendelgen reserves the right to grant licences to use the Software
              to third parties.
            </p>

            <p>
              Termination This EULA agreement is effective from the date you
              first use the Software and shall continue until terminated. You
              may terminate it at any time upon written notice to Mendelgen.
            </p>

            <p>
              It will also terminate immediately if you fail to comply with any
              term of this EULA agreement. Upon such termination, the licenses
              granted by this EULA agreement will immediately terminate and you
              agree to stop all access and use of the Software. The provisions
              that by their nature continue and survive will survive any
              termination of this EULA agreement.
            </p>

            <p>
              Governing Law This EULA agreement, and any dispute arising out of
              or in connection with this EULA agreement, shall be governed by
              and construed in accordance with the laws of us.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Eula;
